import { render, staticRenderFns } from "./Notas.vue?vue&type=template&id=18be8bbe&scoped=true&"
import script from "./Notas.vue?vue&type=script&lang=js&"
export * from "./Notas.vue?vue&type=script&lang=js&"
import style0 from "./Notas.vue?vue&type=style&index=0&id=18be8bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18be8bbe",
  null
  
)

export default component.exports